import { VMLanguages } from "@4pace-cpq/core";

export async function fetchCfgObjectIds(): Promise<string[]> {
  try {
    const response = await fetch(
      "/preview/api/3pq-cs/v2/configuration/configurators",
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data.map((item: { id: string }) => item.id);
  } catch (error) {
    console.error("Failed to fetch configuration objects:", error);
    return [];
  }
}

export interface IlanguageInit {
  searchLanguage: string;
  i18nLanguage: string | null;
  languages: VMLanguages[];
  quoteLanguage: string | unknown;
  callback: (newStatus: string) => void;
}
export const languageInit = ({
  searchLanguage,
  i18nLanguage,
  languages,
  quoteLanguage,
  callback,
}: IlanguageInit): VMLanguages | undefined => {
  const savedLanguage = localStorage.getItem("cpq.languageCode");
  const appLanguage = savedLanguage || "en-US";

  let language;
  if (searchLanguage) {
    language = languages?.find((lang) => lang.languageCode === searchLanguage);
    if (!language) {
      language = languages?.find(
        (lang) => lang.languageCode?.split("-")[0] === searchLanguage,
      );
    }
  } else if (quoteLanguage) {
    if (quoteLanguage === "pt") {
      language = languages?.find((lang) => lang.languageCode === "pt-BR");
    } else {
      language = languages?.find(
        (lang) => lang.languageCode?.split("-")[0] === quoteLanguage,
      );
    }
  } else if (i18nLanguage) {
    language = languages?.find((lang) => lang.languageCode === i18nLanguage);
    if (!language) {
      language = languages?.find(
        (lang) =>
          lang.languageCode?.split("-")[0] === i18nLanguage?.split("-")[0],
      );
    }
  } else {
    language = languages?.find((lang) => lang.languageCode === appLanguage);
    if (!language) {
      language = languages?.find(
        (lang) =>
          lang.languageCode?.split("-")[0] === appLanguage?.split("-")[0],
      );
    }
  }
  //localStorage.setItem("cpq.languageCode", language?.languageCode ?? "");

  if (typeof callback === "function") {
    callback("postInit");
  }
  return language;
};

export const isDevEnvironment =
  window.location.href.includes("dev") ||
  window.location.href.includes("localhost");
export const isStagingEnvironment = window.location.href.includes("stag");
export const isDevOrStagingEnvironment =
  isDevEnvironment || isStagingEnvironment;

export const KIM_API_KEY = isDevEnvironment
  ? "weg_austria_dev"
  : isStagingEnvironment
    ? "weg_austria_stage"
    : "weg_austria_prod";
